module.exports = __webpack_public_path__ + "img/sq.244afce9.svg";